






















































































































































































import {openWebSocket, sendSock, getSock, closeWebSocket} from '@/utils/ws';
import {Tab, Tabs, Button, Dialog, Checkbox, CheckboxGroup, Toast, List, PullRefresh,NoticeBar} from 'vant';
import bus from "@/utils/bus";
import { MESSAGE_PROMPT } from '@/utils/constants'
import expireDialog from "../expireDialog/index.vue";

export default {
  name:"strategy-execution",
  data() {
    return {
      pageTitle: '',
      strategyId: 1,
      strategyList: {
        loadingComplete: false,
        currentTab: '1',
        strategyListItems: [
          // { name: '运行中', numberOfRunningStrategy: 0 }
        ]
      },
      strategyPlanList: {},
      selected:['close','cancel'],
      dialogObj: {
        show: false,
        type: "haltThePlan",
        removeThePlan: {
          text: '您确定要删除本次计划？'
        },
        haltThePlan: {
          text: '计划停止后，策略同时执行如下操作',
          options: {
            selected: ['close','cancel'],
            items: [
              {
                typeName: "平仓",
                type: "close"
              },
              {
                typeName: "撤单",
                type: 'cancel'
              }
            ]
          }
        }
      },
      intervalObj: {
        timeMs: 3000,
        isPending: false,
        intervalId: '',
      },
      symbolObj: {},
      symbolArr: [],

      loading: false,
      finished: true,
      refreshing: false,
      autoId:'',
      allStop:false,
      allStart:false,
      symbolDecimalPlacesObj: {},
      strategyPlanEditingWindow:{
        id: ''
      },
      srcollDomTime:null,
      userInfo:JSON.parse((localStorage as any).getItem('h5userInfo')),
      dataMsg:'',
      dialogShow:false
    }
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NoticeBar.name]: NoticeBar,
    expireDialog
  },
  created() {
    // openWebSocket();
  },
  mounted() {
    // @ts-ignore
    this.headerDot = null;
    bus.$on("onmessage", res => {
      (this as any).wsGetMsg(res)
    })
    setTimeout(() =>{
      if((this as any).$route.query.listId){
        if((window as any).document.querySelector(`#M${(this as any).$route.query.listId}`)){
          (window as any).document.querySelector(`#M${(this as any).$route.query.listId}`).scrollIntoView({
            behavior: "smooth"
          });
          (this as any).operateStrategyItem((this as any).selectedStrategyObj.list.filter(item => item.id == (this as any).$route.query.listId)[0])
        }
      }
    },500)
    // @ts-ignore
    let { strategyId }: any = this.$route.query;
    // 获取锚点定位
    (this as any).handleTitle();
    // 初始化策略计划对象，策略ID作为参数
    (this as any).initializeStrategyPlanObj(strategyId);
    (this as any).getStrategyList().then(() => {
      // 根据策略ID获取计划列表，并处理返回的结果
      (this as any).getPlanListByStrategyId(strategyId).then(res => {
        let symbol = (this as any).symbolArr.join(',');
        (this as any).getContractInfoList();
        // 获取tick快照，使用之前拼接的symbol字符串
        (this as any).getTickSnapshot(symbol);
        // 订阅ticks数据，使用之前拼接的symbol字符串
        (this as any).wsSubTicks(symbol);
        // 开始轮询策略状态，策略ID作为参数
        (this as any).startPolling(strategyId);
        // 标记策略列表加载完成
        (this as any).strategyList.loadingComplete = true;
        (this as any).strategyId = Number(strategyId)
      });
    })




  },
  beforeDestroy() {
    (this as any).stopPolling();
    // closeWebSocket();
    (this as any).$socket.stop();
  },
  computed: {
    selectedStrategyObj() {
      let currentTab = (this as any).strategyId;
      if ((this as any).strategyPlanList[currentTab]) {
        return (this as any).strategyPlanList[currentTab]
      } else {
        return []
      }
    },
    runningPlansNumber() {
      let numberV = 0;
      if ((this as any).selectedStrategyObj.list && Array.isArray((this as any).selectedStrategyObj.list)) {
        for (const item of (this as any).selectedStrategyObj.list) {
          if ((this as any).isRunningStatus(item.operationalStatus)) {
            numberV++;
          }
        }
      }
      return numberV
    },
    stoppedPlansNumber() {
      let numberV = 0;
      if ((this as any).selectedStrategyObj.list && Array.isArray((this as any).selectedStrategyObj.list)) {
        for (const item of (this as any).selectedStrategyObj.list) {
          if ((this as any).isStoppedStatus(item.operationalStatus)) {
            numberV++;
          }
        }
      }
      return numberV
    },
  },
  methods: {
    allRunning() {
      let that:any = this;
      that.allStart = true
      that.$apis.setStrategyStart({strategy_id:that.strategyId,auto_id:0}).then(res =>{
        Toast("已提交全部运行申请，请关注运行状态")
        // 需要补刷新列表的方法
        that.strategyPlanListRefresh();
      })
    },
    allStopped() {
      let that:any = this;
      if(that.dialogObj.haltThePlan.options.selected.length !== 0){
        that.selected = that.dialogObj.haltThePlan.options.selected
      }else{
        that.selected = ['close','cancel']
      }
      that.allStop = true
      that.dialogObj.show = true;
      that.dialogObj.type = 'haltThePlan'
    },
    handCheck(e){
      let that:any = this;
      that.dialogObj.haltThePlan.options.selected = e
      that.selected = e
      
    },
    dialogConfirm(type) {
      let that:any = this;
      if(type === 'removeThePlan'){
        let params:any = {
          strategy_id:that.strategyId,
          auto_id:that.autoId
        };
        that.$apis.delStrategy(params).then(res =>{
          Toast("删除成功")
          that.strategyPlanListRefresh();
        })

      }else{
        let params:any = {
          strategy_id:that.allStop ? that.strategyId : 0,
          auto_id:!that.allStop ? that.autoId :0,
          cancel:1,
          close:1
        }
        if(that.dialogObj.haltThePlan.options.selected.indexOf('cancel') > -1){
          params.cancel = 1
        }else{
          params.cancel = 0
        }
        if(that.dialogObj.haltThePlan.options.selected.indexOf('close') > -1){
          params.close = 1
        }else{
          params.close = 0
        }
        that.$apis.setStrategyStop(params).then(res =>{
          if(that.allStop){
            Toast("已提交全部停止申请，请关注运行状态")
            that.strategyPlanListRefresh();
          }else{
            Toast("已提交停止申请，请关注运行状态")
            that.strategyPlanListRefresh();
          }
        })

      }
    },
    dialogCancel() {
    },
    onLoad() {
    },
    strategyPlanListRefresh() {
      (this as any).finished = false;
      (this as any).loading = true;

      let strategyId = (this as any).strategyId;
      (this as any).stopPolling();
      (this as any).initializeStrategyPlanObj(strategyId);
      (this as any).getPlanListByStrategyId(strategyId).then(() => {
        let symbol = (this as any).symbolArr.join(',');
        (this as any).getContractInfoList();
        (this as any).getTickSnapshot(symbol);
        (this as any).wsSubTicks(symbol);
        (this as any).startPolling(strategyId);
        if ((this as any).refreshing) {
          (this as any).refreshing = false;
        }
        (this as any).loading = false;
        (this as any).finished = true;
      });
    },
    operateStrategyItem(strategyItem) {
      let _this = (this as any);
      if(_this.strategyPlanEditingWindow.id === strategyItem.id){
        _this.strategyPlanEditingWindow.id = '';
      }else {
        _this.strategyPlanEditingWindow.id = strategyItem.id
      }
    },
    createPlan() {
      (this as any).$router.push({
        path: "/h5-create-strategy",
        query: {
          // @ts-ignore
          strategyId: (this as any).strategyId
        }
      });
    },
    getStrategyList() {
      // (this as any).strategyList.loadingComplete = true;
      return (this as any).$apis.getStrategyListApi().then((res) => {
        let resStrategyArr = res.data.data;
        for (const item of resStrategyArr) {
          let obj: any = {
            id: item.strategyId,
            type: item.strategyType,
            name: item.strategyName,
            numberOfRunningStrategy: 0,
          };
          (this as any).strategyList.strategyListItems.push(obj);
          (this as any).initializeStrategyPlanObj(obj.id);

          // (this as any).strategyList.loadingComplete = false;
        }
      }).catch((err) => {
        (this as any).strategyList.loadingComplete = false;
      })
    },
    getPlanListByStrategyId(id) {
      let strategyPlanObj = (this as any).strategyPlanList[id];
      let params = {
        size: strategyPlanObj.pageSize,
        page: strategyPlanObj.page,
        strategy_id: id
      };
      return (this as any).$apis.getPlanListByStrategyIdApi(params).then((res) => {
        let planListArr = res.data.data.data;

        let newData: any = [];
        // 更新可运行的数量
        let strategyInfoArr = res.data.data.id_data || [];
        // 遍历策略列表中的每个策略项
        (this as any).strategyList.strategyListItems.forEach( item => {
          const index = strategyInfoArr.findIndex((cItem: any) => cItem.strategy_id == item.type);
          if (index != -1) {
            // 将匹配元素中的策略数量赋值给当前策略项的运行策略数量属性
            item.numberOfRunningStrategy = strategyInfoArr[index].strategy_num;
          } else {
            // 如果没有找到匹配的元素，将运行策略数量属性设为0
            item.numberOfRunningStrategy = 0;
          }
        })
        let foreignKey:any = []

        if (planListArr !== null && planListArr !== undefined) {
          for (let planItme of planListArr) {
            planItme.strategy_param = JSON.parse(planItme.strategy_param);
            planItme.trade_param = JSON.parse(planItme.trade_param);
            foreignKey.push(planItme.auto_id)

            let obj: any = {
              id: planItme.auto_id,
              account: planItme.account_no,
              operator: planItme.realName,
              contractCode: planItme.contract_no,
              contractCodeName: planItme.origin_symbol || `${planItme.commodity_no}${planItme.contract_no}`,
              lotSize: planItme.strategy_param.count,
              operationalStatus: planItme.status,
              operationalStatusName: (this as any).runningNameByStatus(planItme.status),
              strategyId: planItme.strategy_id,
              symbol: planItme.symbol,
              openEditingWindow: false,
              strategy_type: planItme.strategy_type,
              isOverNight: planItme.strategy_param.isOverNight,
              status:planItme.status,
              account_type:planItme.account_type,
              strategy_accounts:planItme.strategy_accounts,
              reference_lots:planItme.trade_param.reference_lots,
              action_auth:planItme.action_auth,
              order_type:planItme.order_type
            };
            // 策略类型为1的情况下 解析大小值以及网格
            if (planItme.strategy_type === 1) {
              obj.priceRange = `${planItme.strategy_param.min}~${planItme.strategy_param.max}`;
              obj.gridSize = planItme.strategy_param.grid_size;
            } else if (planItme.strategy_type === 2) {
              // 根据策略参数设置订单方向
              obj.order_side = planItme.strategy_param.order_side;
            }
            if((this as any).selectedStrategyObj.list.length != 0){
              (this as any).selectedStrategyObj.list.forEach(item =>{
                if(item.id == obj.id){
                  obj.messageObj = item.messageObj
                }
              })
            }
            newData.push(obj);
          }
          (this as any).symbolArr = Object.keys((this as any).collectSymbols(planListArr));
          (this as any).getStationMessagelastList(foreignKey,newData)
        }
        (this as any).strategyPlanList[id.toString()].list = newData




      }).catch((err) => {
      })
    },
    tabsChange(name, title) {
      (this as any).updateTitle(name);
      (this as any).stopPolling();
      (this as any).initializeStrategyPlanObj(name);
      (this as any).getPlanListByStrategyId(name).then(res => {
        let symbol = (this as any).symbolArr.join(',');
        (this as any).getContractInfoList();
        (this as any).getTickSnapshot(symbol);
        (this as any).wsSubTicks(symbol);
        (this as any).startPolling(name);
        // @ts-ignore
        (this as any).strategyId = name

      });
    },
    updateTitle(name) {
      const that = (this as any);
      // 查找相应的策略列表项
      const item = that.strategyList.strategyListItems.find(item => item.id === name);
      // 更新标题
      if (item) {
        that.pageTitle = item.name;
      }
    },
    initializeStrategyPlanObj(id) {
      let _this = (this as any)
      let key = id.toString();
      const obj: any = {
        page: 1,
        pageSize: 200,
        total: 0,
        list: [],
      };
      (this as any).$set((this as any).strategyPlanList, key, obj);
      (this as any).symbolObj = {};
      (this as any).symbolArr = [];
      _this.strategyPlanEditingWindow.id = '';
    },
    handleTitle() {
      const that = this as any
      const { strategyId }: any = that.$route.query;
      const keyValue = {
        1: '网格策略', 2: '开盘动量', 3: '日内短线'
      }
      that.pageTitle = keyValue[strategyId] || '';
    },
    runningNameByStatus(Status) {
      let statusName = ''
      switch (Number(Status)) {
        case 1:
          statusName = "已停止";
          break;
        case 2:
          statusName = "运行中";
          break;
        case 3:
          statusName = "启动中";
          break;
        case 4:
          statusName = "停止中";
          break;
      }
      return statusName
    },
    runningCssByStatus(Status) {
      let statusCss = ''
      switch (Number(Status)) {
        case 1:
          statusCss = "status-stopped";
          break;
        case 2:
          statusCss = "status-running";
          break;
        case 3:
          statusCss = "status-starting";
          break;
        case 4:
          statusCss = "status-stopping";
          break;
      }
      return statusCss
    },
    strategyPlanRun(strategyId, strategyPlanId) {
      (this as any).$apis.setStrategyStart({strategy_id:0,auto_id:strategyPlanId}).then(res =>{
        if(res.data.error_code == 0 && res.data.error_msg == 'OK'){
          Toast("已提交运行申请，请关注运行状态")
        }else{
          (this as any).dialogShow = !(this as any).dialogShow;
          (this as any).dataMsg = res.data.error_msg;
        }
      })
    },
    strategyPlanEdit(strategyId, strategyPlanId) {
      (this as any).$router.push({
        path: '/h5-create-strategy',
        query: {
          auto_id: strategyPlanId,
          strategyId
        }
      })
    },
    strategyPlanDelete(strategyId, strategyPlanId) {
      let that:any = this
      that.autoId = strategyPlanId
      that.dialogObj.show = true;
      that.dialogObj.type = 'removeThePlan'
    },
    strategyPlanStop(strategyId, strategyPlanId) {
      let that:any = this
      that.autoId = strategyPlanId
      that.dialogObj.show = true;
      that.dialogObj.type = 'haltThePlan'
      that.allStop = false
    },
    isRunningStatus(state) {
      // 运行中
      return state === 2
    },
    isStoppedStatus(state) {
      // 已停止
      return state === 1
    },
    startPolling(id) {
      (this as any).intervalObj.intervalId = setInterval(() => {
        if (!(this as any).intervalObj.isPending) {
          (this as any).intervalObj.isPending = true;
          (this as any).getPlanListByStrategyId(id).then(() => {
            (this as any).getContractInfoList();
            (this as any).intervalObj.isPending = false;
          });
        }
      }, (this as any).intervalObj.timeMs);
    },
    stopPolling() {
      clearInterval((this as any).intervalObj.intervalId);
    },
    // 获取最新站内消息
    getStationMessagelastList(keyArray,newData){
      let params = {
        foreignKey:keyArray,
        ...MESSAGE_PROMPT,
        userId:String((this as any).userInfo.id)
      }

      return (this as any).$apis.getStationMessagelastListApi(params).then(res =>{
        const { infos } = res
        if(res && infos){
          newData.forEach(item =>{
            item.messageObj = infos.find(items => items.foreignKey == item.id)
          })
        }else{
          // this.selectedStrategyObj.list.forEach(item =>{
          //   item.messageObj = ''
          // })
        }
      })

    },
    // 更新已读
    handMessageClose(item){
      (this as any).$apis.getStationMessageReadSetApi({
        userId:String((this as any).userInfo.id),
        messageTargetIds:[item.id]
      }).then(res =>{
        if(res){
          (this as any).getPlanListByStrategyId((this as any).$route.query.strategyId);
        }
      })
    },



    //
    wsSubTicks(symbol) {
      let struct = {
        MsgType: 'SubTicks',
        MsgBody: {
          symbol: symbol // "symbol1、symbol2、..."
        }
      };
      (this as any).$socket.sendMsg(struct);
      // getSock(this.wsGetMsg);
    },
    wsGetMsg(msg) {
      let _this = (this as any);
      let obj :any = {
        ..._this.symbolObj[msg.symbol],
        ...msg
      }
      if(msg.symbol){
        (this as any).$set(_this.symbolObj, msg.symbol, obj);
      }
    },
    collectSymbols(array) {
      const symbolObject: any = {};
      array.forEach(obj => {
        if (obj.symbol) {
          symbolObject[obj.symbol.toString()] = {};
        }
      });
      return symbolObject;
    },
    parseFloatNumber(val,len){
      if(val !== undefined && val !== null && val !== ''){
        return parseFloat(val).toFixed(len);
      } else {
        return '--'
      }
    },
    getContractInfoList(){
      const _this = (this as any)
      // 兼容判断 数组
      if (Array.isArray(_this.symbolArr)) {
        // 兼容判断 数组长度
        if (_this.symbolArr.length > 0) {

          let symbol = _this.symbolArr.join(',');
          _this.$apis.getContractInfo({symbol,isExpired:2}).then(res => {
            let infoArr = res.data.contract_info;
            for (const item of infoArr){
              _this.symbolDecimalPlacesObj[item.symbol] = item.digits;
            }
          });
        }

      }
    },
    getTickSnapshot(symbol) {
      let _this = (this as any);
      _this.$apis.future_ticksnapshot({
        symbol
      }).then(res =>{
        let tickSnapshotArr = []
        if(res.data.future_ticks){
          tickSnapshotArr = res.data.future_ticks;
          for (const item of tickSnapshotArr as any) {
            (this as any).$set(_this.symbolObj, item.symbol, item);
          }
        }
      })
    },
    handUpdate(e){
      if(e){
        (this as any).dialogShow = !(this as any).dialogShow;
      }
    }
  }
}
